module.exports = __webpack_public_path__ + "static/media/400044_02.e3591f0d.png";